import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ 
  dateRange, 
  filters, 
  onDateRangeChange, 
  onFiltersChange, 
  onScheduleReport,
  selectedCategory 
}) => {
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleSettings, setScheduleSettings] = useState({
    frequency: 'weekly',
    dayOfWeek: 'monday',
    time: '09:00',
    recipients: ''
  });

  const handleDateRangeChange = (field, value) => {
    onDateRangeChange({
      ...dateRange,
      [field]: value
    });
  };

  const handleFilterChange = (field, value) => {
    onFiltersChange({
      ...filters,
      [field]: value
    });
  };

  const handleScheduleSubmit = () => {
    onScheduleReport(scheduleSettings);
    setScheduleModalOpen(false);
    setScheduleSettings({
      frequency: 'weekly',
      dayOfWeek: 'monday',
      time: '09:00',
      recipients: ''
    });
  };

  const quickDateRanges = [
    { label: 'Últimos 7 días', value: 7 },
    { label: 'Últimos 30 días', value: 30 },
    { label: 'Último trimestre', value: 90 },
    { label: 'Último año', value: 365 }
  ];

  const setQuickDateRange = (days) => {
    const endDate = new Date().toISOString().split('T')[0];
    const startDate = new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    onDateRangeChange({ startDate, endDate });
  };

  return (
    <div className="space-y-4">
      {/* Date Range Controls */}
      <div className="card">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-heading-semibold text-text-primary flex items-center">
            <Icon name="Calendar" size={18} className="mr-2" />
            Rango de Fechas
          </h3>
        </div>
        <div className="p-4 space-y-4">
          {/* Quick Date Ranges */}
          <div>
            <label className="block text-sm font-body-medium text-text-secondary mb-2">
              Rangos Rápidos
            </label>
            <div className="grid grid-cols-1 gap-2">
              {quickDateRanges.map((range) => (
                <button
                  key={range.value}
                  onClick={() => setQuickDateRange(range.value)}
                  className="w-full text-left px-3 py-2 text-sm text-text-secondary hover:text-text-primary hover:bg-secondary-50 rounded-md transition-micro"
                >
                  {range.label}
                </button>
              ))}
            </div>
          </div>

          {/* Custom Date Range */}
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-body-medium text-text-secondary mb-1">
                Fecha Inicio
              </label>
              <input
                type="date"
                value={dateRange.startDate}
                onChange={(e) => handleDateRangeChange('startDate', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
              />
            </div>
            <div>
              <label className="block text-sm font-body-medium text-text-secondary mb-1">
                Fecha Fin
              </label>
              <input
                type="date"
                value={dateRange.endDate}
                onChange={(e) => handleDateRangeChange('endDate', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Advanced Filters */}
      <div className="card">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-heading-semibold text-text-primary flex items-center">
            <Icon name="Filter" size={18} className="mr-2" />
            Filtros Avanzados
          </h3>
        </div>
        <div className="p-4 space-y-4">
          {selectedCategory === 'sales' && (
            <>
              <div>
                <label className="block text-sm font-body-medium text-text-secondary mb-1">
                  Departamento
                </label>
                <select
                  value={filters.department}
                  onChange={(e) => handleFilterChange('department', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                >
                  <option value="">Todos los departamentos</option>
                  <option value="ventas">Ventas</option>
                  <option value="marketing">Marketing</option>
                  <option value="soporte">Soporte</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-body-medium text-text-secondary mb-1">
                  Producto
                </label>
                <select
                  value={filters.product}
                  onChange={(e) => handleFilterChange('product', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                >
                  <option value="">Todos los productos</option>
                  <option value="producto-a">Producto A</option>
                  <option value="producto-b">Producto B</option>
                  <option value="producto-c">Producto C</option>
                </select>
              </div>
            </>
          )}

          {selectedCategory === 'customers' && (
            <>
              <div>
                <label className="block text-sm font-body-medium text-text-secondary mb-1">
                  Segmento de Cliente
                </label>
                <select
                  value={filters.customer}
                  onChange={(e) => handleFilterChange('customer', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                >
                  <option value="">Todos los segmentos</option>
                  <option value="premium">Premium</option>
                  <option value="frecuente">Frecuente</option>
                  <option value="nuevo">Nuevo</option>
                  <option value="ocasional">Ocasional</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-body-medium text-text-secondary mb-1">
                  Región
                </label>
                <select
                  value={filters.region}
                  onChange={(e) => handleFilterChange('region', e.target.value)}
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                >
                  <option value="">Todas las regiones</option>
                  <option value="madrid">Madrid</option>
                  <option value="cataluna">Cataluña</option>
                  <option value="andalucia">Andalucía</option>
                  <option value="valencia">Valencia</option>
                </select>
              </div>
            </>
          )}

          {selectedCategory === 'inventory' && (
            <div>
              <label className="block text-sm font-body-medium text-text-secondary mb-1">
                Categoría de Producto
              </label>
              <select
                value={filters.category}
                onChange={(e) => handleFilterChange('category', e.target.value)}
                className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
              >
                <option value="">Todas las categorías</option>
                <option value="electronica">Electrónica</option>
                <option value="herramientas">Herramientas</option>
                <option value="materiales">Materiales</option>
              </select>
            </div>
          )}

          <button
            onClick={() => onFiltersChange({ department: '', product: '', customer: '', region: '' })}
            className="w-full text-sm text-text-secondary hover:text-text-primary transition-micro"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>

      {/* Report Scheduling */}
      <div className="card">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-heading-semibold text-text-primary flex items-center">
            <Icon name="Clock" size={18} className="mr-2" />
            Programación de Reportes
          </h3>
        </div>
        <div className="p-4 space-y-4">
          <button
            onClick={() => setScheduleModalOpen(true)}
            className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-body-medium rounded-md text-white bg-primary hover:bg-primary-600 transition-micro"
          >
            <Icon name="Plus" size={16} className="mr-2" />
            Programar Reporte
          </button>

          <div className="text-sm text-text-secondary">
            <p className="mb-2">Reportes Programados:</p>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-secondary-50 rounded">
                <span>Ventas Semanales</span>
                <span className="text-xs text-success">Activo</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-secondary-50 rounded">
                <span>Inventario Mensual</span>
                <span className="text-xs text-success">Activo</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Export Options */}
      <div className="card">
        <div className="p-4 border-b border-border">
          <h3 className="text-lg font-heading-semibold text-text-primary flex items-center">
            <Icon name="Download" size={18} className="mr-2" />
            Opciones de Exportación
          </h3>
        </div>
        <div className="p-4 space-y-3">
          <button className="w-full flex items-center justify-center px-4 py-2 border border-border text-sm font-body-medium rounded-md text-text-secondary bg-surface hover:bg-secondary-50 transition-micro">
            <Icon name="FileText" size={16} className="mr-2" />
            Exportar como PDF
          </button>
          <button className="w-full flex items-center justify-center px-4 py-2 border border-border text-sm font-body-medium rounded-md text-text-secondary bg-surface hover:bg-secondary-50 transition-micro">
            <Icon name="FileSpreadsheet" size={16} className="mr-2" />
            Exportar como Excel
          </button>
          <button className="w-full flex items-center justify-center px-4 py-2 border border-border text-sm font-body-medium rounded-md text-text-secondary bg-surface hover:bg-secondary-50 transition-micro">
            <Icon name="Database" size={16} className="mr-2" />
            Exportar datos CSV
          </button>
        </div>
      </div>

      {/* Schedule Modal */}
      {scheduleModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-surface p-6 rounded-lg w-full max-w-md mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-heading-semibold text-text-primary">
                Programar Reporte
              </h3>
              <button
                onClick={() => setScheduleModalOpen(false)}
                className="p-1 text-text-secondary hover:text-text-primary transition-micro"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-body-medium text-text-secondary mb-1">
                  Frecuencia
                </label>
                <select
                  value={scheduleSettings.frequency}
                  onChange={(e) => setScheduleSettings({...scheduleSettings, frequency: e.target.value})}
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                >
                  <option value="daily">Diario</option>
                  <option value="weekly">Semanal</option>
                  <option value="monthly">Mensual</option>
                </select>
              </div>

              {scheduleSettings.frequency === 'weekly' && (
                <div>
                  <label className="block text-sm font-body-medium text-text-secondary mb-1">
                    Día de la semana
                  </label>
                  <select
                    value={scheduleSettings.dayOfWeek}
                    onChange={(e) => setScheduleSettings({...scheduleSettings, dayOfWeek: e.target.value})}
                    className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                  >
                    <option value="monday">Lunes</option>
                    <option value="tuesday">Martes</option>
                    <option value="wednesday">Miércoles</option>
                    <option value="thursday">Jueves</option>
                    <option value="friday">Viernes</option>
                  </select>
                </div>
              )}

              <div>
                <label className="block text-sm font-body-medium text-text-secondary mb-1">
                  Hora
                </label>
                <input
                  type="time"
                  value={scheduleSettings.time}
                  onChange={(e) => setScheduleSettings({...scheduleSettings, time: e.target.value})}
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                />
              </div>

              <div>
                <label className="block text-sm font-body-medium text-text-secondary mb-1">
                  Destinatarios (emails separados por coma)
                </label>
                <textarea
                  value={scheduleSettings.recipients}
                  onChange={(e) => setScheduleSettings({...scheduleSettings, recipients: e.target.value})}
                  placeholder="usuario@empresa.com, gerente@empresa.com"
                  className="w-full px-3 py-2 border border-border rounded-md bg-surface text-text-primary text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-micro"
                  rows={3}
                />
              </div>
            </div>

            <div className="flex items-center justify-end space-x-3 mt-6">
              <button
                onClick={() => setScheduleModalOpen(false)}
                className="px-4 py-2 text-sm font-body-medium text-text-secondary border border-border rounded-md hover:bg-secondary-50 transition-micro"
              >
                Cancelar
              </button>
              <button
                onClick={handleScheduleSubmit}
                className="px-4 py-2 text-sm font-body-medium text-white bg-primary rounded-md hover:bg-primary-600 transition-micro"
              >
                Programar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterControls;